<template>
  <ul v-if="permissions.length">
    <li>
      <strong class="text-alert">
        {{ $t('APP.ACTIONS.DANGEROUS_PERMISSIONS') }}
      </strong>

      <p class="text-alert">
        {{ $t('APP.ACTIONS.DANGEROUS_PERMISSIONS_DESC') }}
      </p>

      <ElCollapse v-model="activeCollapseItem" accordion>
        <ElCollapseItem
          v-for="permission in permissions"
          :key="permission.permissionName"
          :title="permission.permissionName"
          :name="permission.permissionName"
        >
          <div v-dompurify-html="permission.description" />
        </ElCollapseItem>
      </ElCollapse>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'DangerousPermissions',
  props: {
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeCollapseItem: '',
    };
  },
};
</script>
